import { frFR } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';

const theme = createTheme(
  {
    palette: {
      mode: 'light',
      primary: {
        main: '#0d7c7f', // Teal accessible — ≈5.0:1 sur blanc ✓ RGAA AA
        light: '#35cacf', // Cyan d'origine — usage décoratif (fonds, badges)
      },
      secondary: {
        main: '#cf3a35', // Rouge — ≈4.9:1 sur blanc ✓ RGAA AA (inchangé)
      },
      warning: {
        main: '#a82da8', // Magenta sombre — ≈5.8:1 sur blanc ✓ RGAA AA
      },
    },
  },
  frFR,
);

export default theme;
